export default "__VITE_ASSET__79b969d8__"